import React, { useState, useCallback } from 'react'
import { ActionElement } from 'react-querybuilder'
import { FaTimes } from 'react-icons/fa'
import ConfirmationModal from '../../../../../features/reporting/ConfirmationModal'

const AddGroupActionElement = props => {
    if (props.context && props.context.viewOnly) {
        return null
    }
    return (
        <ActionElement
            {...props}
            className='ruleGroup-addGroup button is-info'
            label={'+ Group'}
        />
    )
}

const AddRuleActionElement = props => {
    if (props.context && props.context.viewOnly) {
        return null
    }
    return (
        <ActionElement
            {...props}
            className='ruleGroup-addRule button is-info'
            label={'+ Rule'}
        />
    )
}

const RemoveGroupActionElement = props => {
    const { context, handleOnClick, path } = props
    const [showConfirmation, setShowConfirmation] = useState(false)

    const {
        deleteGroupClassName = 'delete-button',
        deleteGroupTitle = 'Delete group',
        showGroupDeleteConfirmation = true,
        groupDeleteConfirmationTitle = 'Delete Group Confirmation',
        groupDeleteConfirmationMessage = 'Are you sure you want to delete this group of rules?',
        groupDeleteConfirmText = 'Delete',
        groupDeleteCancelText = 'Cancel',
        onDeleteGroup,
    } = context || {}

    const handleDelete = useCallback(() => {
        if (onDeleteGroup) {
            onDeleteGroup(path)
        }

        if (handleOnClick) {
            handleOnClick()
        }

        setShowConfirmation(false)
    }, [onDeleteGroup, handleOnClick, path])

    const handleClick = useCallback(() => {
        if (showGroupDeleteConfirmation) {
            setShowConfirmation(true)
        } else {
            handleDelete()
        }
    }, [showGroupDeleteConfirmation, handleDelete])

    const handleCancel = useCallback(() => {
        setShowConfirmation(false)
    }, [])

    if (context?.viewOnly) return null

    return (
        <>
            <div
                className={deleteGroupClassName}
                title={deleteGroupTitle}
                onClick={handleClick}
            >
                <span className='icon' style={{ marginTop: 4 }}>
                    <FaTimes />
                </span>
            </div>
            {showGroupDeleteConfirmation && (
                <ConfirmationModal
                    display={showConfirmation}
                    title={groupDeleteConfirmationTitle}
                    confirmAction={handleDelete}
                    confirmText={groupDeleteConfirmText}
                    denyAction={handleCancel}
                    denyText={groupDeleteCancelText}
                >
                    <p>{groupDeleteConfirmationMessage}</p>
                </ConfirmationModal>
            )}
        </>
    )
}

const RemoveRuleActionElement = props => {
    const { context, handleOnClick, path } = props
    const [showConfirmation, setShowConfirmation] = useState(false)

    const {
        deleteRuleClassName = 'delete-button',
        deleteRuleTitle = 'Delete rule',
        showRuleDeleteConfirmation = true,
        ruleDeleteConfirmationTitle = 'Delete Rule Confirmation',
        ruleDeleteConfirmationMessage = 'Are you sure you want to delete this rule?',
        ruleDeleteConfirmText = 'Delete',
        ruleDeleteCancelText = 'Cancel',
        onDeleteRule,
    } = context || {}

    const handleDelete = useCallback(() => {
        if (onDeleteRule) {
            onDeleteRule(path)
        }

        if (handleOnClick) {
            handleOnClick()
        }

        setShowConfirmation(false)
    }, [onDeleteRule, handleOnClick, path])

    const handleClick = useCallback(() => {
        if (showRuleDeleteConfirmation) {
            setShowConfirmation(true)
        } else {
            handleDelete()
        }
    }, [showRuleDeleteConfirmation, handleDelete])

    const handleCancel = useCallback(() => {
        setShowConfirmation(false)
    }, [])

    if (context?.viewOnly) return null

    return (
        <>
            <div
                className={deleteRuleClassName}
                title={deleteRuleTitle}
                onClick={handleClick}
            >
                <span className='icon' style={{ marginTop: 8 }}>
                    <FaTimes />
                </span>
            </div>
            {showRuleDeleteConfirmation && (
                <ConfirmationModal
                    display={showConfirmation}
                    title={ruleDeleteConfirmationTitle}
                    confirmAction={handleDelete}
                    confirmText={ruleDeleteConfirmText}
                    denyAction={handleCancel}
                    denyText={ruleDeleteCancelText}
                >
                    <p>{ruleDeleteConfirmationMessage}</p>
                </ConfirmationModal>
            )}
        </>
    )
}

export {
    AddGroupActionElement,
    AddRuleActionElement,
    RemoveGroupActionElement,
    RemoveRuleActionElement,
}
